export default {"src":"https://webcdn.trailways.ca/_next/static/media/location.b2176fd7.svg","height":180,"width":180,"blurWidth":0,"blurHeight":0};